import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/free-solid-svg-icons/faBuilding';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { useProviderContextStore } from '../../stores';
import { cn } from '../../utils';
import { GlobalRating } from '../userProfile/GlobalRating';
import { formatProviderDisplayName, formatProviderRole } from './providerFormatting';

interface ProviderContextBadgeProps {
    onClick?: () => void;
    compact?: boolean;
}

export function ProviderContextBadge({ onClick, compact = false }: ProviderContextBadgeProps) {
    const activeContext = useProviderContextStore((state) => state.activeContext);
    const contexts = useProviderContextStore((state) => state.contexts);

    if (!activeContext) {
        return null;
    }

    const canSwitch = contexts.filter((context) => context.can_operate).length > 1;
    const content = (
        <>
            <span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <FontAwesomeIcon icon={activeContext.is_individual ? faUser : faBuilding} aria-hidden="true" />
            </span>
            <span className="min-w-0 flex-1 text-left">
                <span className="block truncate text-xs font-semibold text-text">
                    {formatProviderDisplayName(activeContext.provider.display_name, activeContext.is_individual)}
                </span>
                <GlobalRating rating={activeContext.provider.rating_summary ?? null} className="mt-0.5" />
                {!compact ? (
                    <span className="block truncate text-[11px] text-text-muted">
                        {formatProviderRole(activeContext.role)}
                    </span>
                ) : null}
            </span>
            {canSwitch && onClick ? (
                <FontAwesomeIcon icon={faChevronRight} className="size-3 shrink-0 text-text-muted" aria-hidden="true" />
            ) : null}
        </>
    );

    if (!onClick || !canSwitch) {
        return (
            <div className="flex min-w-0 items-center gap-2 rounded-xl border border-border bg-surface px-2 py-1.5">
                {content}
            </div>
        );
    }

    return (
        <button
            type="button"
            onClick={onClick}
            className={cn(
                'flex min-h-12 min-w-0 items-center gap-2 rounded-xl border border-border bg-surface px-2 py-1.5',
                'transition active:scale-[0.99] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35',
            )}
            aria-label="Cambiar contexto de proveedor"
        >
            {content}
        </button>
    );
}
